import axios from 'axios';

import { type UserFeedback } from '../types/userFeedback';

async function submitFeedbackForm(feedback: UserFeedback): Promise<null> {
    return axios.post('/api/feedback', feedback);
}

export { submitFeedbackForm };
